import { ArrayFieldTemplateProps } from "react-jsonschema-form-bs4";
import * as React from "react";

export default (props: ArrayFieldTemplateProps, onRemove?: (item: any) => Promise<Boolean>) => {
    return <div className={props.className}>
          {props.items && props.items.map(element => (
              <div className="card mb-3" key={element.index}>
                <div className="card-body">
                    {element.children}
                    <div className="d-flex justify-content-center float-right">
                        <button className="btn btn-secondary" type="button" onClick={async (e) => {

                            // Check for function to call first
                            if (!onRemove || await onRemove(props.formData[element.index])) {
                                // Remove from UI
                                element.onDropIndexClick(element.index)(e);
                            };
                        }}>
                            Delete {props.title}
                        </button>
                    </div>
                </div>
              </div>))}

            {props.canAdd && <div className="d-flex justify-content-center float-left">
                <button onClick={props.onAddClick} type="button" className="btn btn-primary">
                    Add {props.title}
                </button>
            </div>}
        </div>;
}
